import { useQuery } from "@tanstack/react-query";
import { ICellRendererParams } from "ag-grid-community";
import { useTranslation } from "react-i18next";
import { getLocations } from "../../../../api/services";
import { IRule, ReactQueryKey } from "../../../../types";
import { useRecoilValue } from "recoil";
import { rulesFilterState } from "../../recoil";

const CellPickupLocations = (params: ICellRendererParams<IRule>) => {

    const { t } = useTranslation('booking');

    const rulesFilter = useRecoilValue(rulesFilterState);
    const { tenants, dealers } = rulesFilter || {};

    const locationsQuery = useQuery({
        queryKey: [ReactQueryKey.Locations, tenants, dealers],
        queryFn: () => getLocations({tenants, dealers}),
    });

    const {
        pickupLocations,
        excludedPickupLocations
    } = params.data ?? {};

    if (!pickupLocations || pickupLocations.length === 0)
        return '-';

    return pickupLocations
            .reduce((prev: string[], curr) => {
                const founded = locationsQuery.data?.locations.find(v => v.id === curr)
                if (founded) {
                    prev.push(founded.label)
                }
                return prev;
            }, [])
            .join(', ')
        + (excludedPickupLocations ? ` (${t('label.excluded')})` : '');
};

export default CellPickupLocations;